module.exports = __webpack_public_path__ + "img/ManHoleDown.7d4ef4b3.svg";